
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PageHeader',

  props: {
    /**
     * Main page title
     */
    title: {
      type: String,
      required: true,
    },

    /**
     * Page description/summary (optional)
     */
    summary: {
      type: String,
      default: '',
    },

    /**
     * Back link route (optional) - Can be a string path or a route object
     */
    backLinkTo: {
      type: [String, Object],
      default: '',
    },

    /**
     * Back link text (optional)
     */
    backLinkText: {
      type: String,
      default: '',
    },
  },
});
